export const aiIconRowOne=[
    {
        icon:require('@/assets/imgcaptions/icon_gongneng1.svg'),
        name:'智能识别字幕'
    },
    {
        icon:require('@/assets/imgcaptions/icon_gongneng2.svg'),
        name:'自动生成时间码'
    },
    {
        icon:require('@/assets/imgcaptions/icon_gongneng3.svg'),
        name:'剧本辅助识别'
    },
    {
        icon:require('@/assets/imgcaptions/icon_gongneng4.svg'),
        name:'多文件格式导出'
    },
    {
        icon:require('@/assets/imgcaptions/icon_gongneng5.svg'),
        name:'智能人物识别'
    }
 
]

export const aiIconRowTwo=[
    {
        icon:require('@/assets/imgcaptions/icon_gongneng6.svg'),
        name:'丰富格式识别'
    },
    {
        icon:require('@/assets/imgcaptions/icon_gongneng7.svg'),
        name:'多模式切换'
    },
    {
        icon:require('@/assets/imgcaptions/icon_gongneng8.svg'),
        name:'高精度识别'
    },
    {
        icon:require('@/assets/imgcaptions/icon_gongneng9.svg'),
        name:'灵活多人协作'
    },
    {
        icon:require('@/assets/imgcaptions/icon_gongneng10.svg'),
        name:'多语种翻译'
    },
]
export const aitext=['3GP', 'ASF', 'AVI','DAT','DV' ,'FLV','F4V','GIF','M2T', 'M4V','MJ2' , 'MJPEG', 'MKV', 'MOV',
     'MP4', 'MPE', 'MPG','MPEG', 'MTS', 'OGG', 'QT', 'RM', 'RMVB', 'SWF', 'TS', 'VOB','WMV', 'WEBM']
export const aitextOther=['MP3',  'MP4', 'WAV' ,'AVI' , 'SWF' , 'MPG' , 'ASF', 'MOV','3GP', 'MKV']
export const languageList=[
    { text: '中文', value: 'cn' },
    { text: '英语', value: 'en' },
    { text: '韩语', value: 'ko' },
    { text: '法语', value: 'fr' },
    { text: '德语', value: 'de' },
    { text: '俄语', value: 'ru' },
    { text: '泰语', value: 'th' },
    { text: '西班牙语', value: 'es' },
    { text: '意大利语', value: 'it' },
    { text: '日语', value: 'ja' },
]
export const styleList=[
    { text: '通用', value: '' },
    { text: '历史', value: '历史' },
    { text: '武侠', value: '武侠' },
    { text: '都市', value: '都市' },
    { text: '家庭', value: '家庭' },
    { text: '科幻', value: '科幻' },
    { text: '自定义', value: '自定义' }
]
export const controlType=[
    { text: '编辑时间', value: 'modifyTime' },
    { text: '编辑角色', value: 'modifyRole' },
    { text: '原文编辑', value: 'modifyOriginalText' },
    { text: '译文编辑', value: 'modifyTranslationText' },
    { text: '原文标注颜色编辑', value: 'modifyOriginalColor' },
    { text: '译文标注颜色编辑', value: 'modifyTranslationColor' },
    { text: '添加', value: 'add' },
    { text: '删除', value: 'delete' },
    { text: '撤销删除', value: 'restore' },
    { text: '原文替换', value: 'originalTextReplace' },
    { text: '译文替换', value: 'translationTextReplace' },
]

export const applicationDetail={
    // caption:{
    //     name:'',
    //     version:''
    // },
    // chatGtp:{
    //     name:'',
    //     version:''
    // },
    // aiVoice:{
    //     name:'',
    //     version:''
    // }
    caption:{
        name:'灵犀',
        version:'2.4.3'
    },
    chatGtp:{
        name:'万物智文',
        version:'2.0'
    },
    aiVoice:{
        name:'幻音',
        version:'1.4'
    }
}

export const aiModelList=[
    {
        value: 'GTP',
        label: 'GTP',
        children: [
          {
            value: 'GTP3.5ID',
            label: 'GTP3.5',
          }
        ]
    },
    {
        value: '文心一言',
        label: '文心一言',
        children: [
          {
            value: '文心一言ID',
            label: '文心一言1.1',
          }
        ]
    },
]


export const soundFieList=[
    {
        value: '0',
        label: '原始',
    },
    {
        value: '1',
        label: '房间',
    },
    {
        value: '2',
        label: '车内',
    },
    {
        value: '3',
        label: '大厅',
    },
    {
        value: '4',
        label: '客厅',
    },
    {
        value: '5',
        label: '走廊',
    },
    {
        value: '6',
        label: '隔壁',
    },
]
